/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vexed_Legal_Piranha_StabInputs */

const fr_vexed_legal_piranha_stab = /** @type {(inputs: Vexed_Legal_Piranha_StabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`surchargé`)
};

/**

* @param {Vexed_Legal_Piranha_StabInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vexed_legal_piranha_stab = /** @type {((inputs?: Vexed_Legal_Piranha_StabInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vexed_Legal_Piranha_StabInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vexed_legal_piranha_stab(inputs)
});